import { connect } from "react-redux";
import { getShortAddress } from "../../../utils";
import ArchGarland from "../art/ArchGarland";
import Reveal from "../Reveal";
import Section from "./Section";

const mapsLink = (venue) => `https://www.google.com/maps?q=${encodeURIComponent(`${venue}`)}`;

// Each ceremony's card takes the next colour of the mela.
const COLORS = ["rani", "marigold", "teal", "parrot", "purple"];

/**
 * "When & Where": each ceremony in an arched card, a genda phool mala laid over the
 * top of its arch (art/ArchGarland.js) with its ends hanging in the card's colour.
 */
const Events = ({ events }) => (
  <Section
    id="story"
    className="ut-events"
    label="When and where"
    kicker="Our Wedding"
    title="When & Where"
    deco={["petals", "butterflies"]}
    seed={61}
  >
    <div className="ut-events__list">
      {(events || []).map((event, i) => {
        const color = COLORS[i % COLORS.length];
        return (
          <Reveal key={`${event.name}-${i}`} className="ut-events__slot" delay={0.1 + (i % 3) * 0.12}>
            <article className={`ut-event ut-event--${color}`}>
              <ArchGarland radius={170} seed={20 + i} />
              <h3 className="ut-event__name">{event.name}</h3>
              <p className="ut-kicker ut-event__date">{event?.dateAndTime?.date}</p>
              <p className="ut-event__time">{event?.dateAndTime?.time} Onwards</p>
              {event.theme && (
                <p className="ut-event__dress">
                  {event.theme.includes("Dinner is also") ? "" : "Dress Code - "}
                  {event.theme}
                </p>
              )}
              <a className="ut-event__venue" href={mapsLink(event?.venue)} target="_blank" rel="noreferrer">
                {getShortAddress(event?.venue)}
              </a>
            </article>
          </Reveal>
        );
      })}
    </div>
  </Section>
);

const mapStateToProps = (state) => ({
  events: state.inviteDetails.invite?.events,
});

export default connect(mapStateToProps)(Events);
